"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleApiError = void 0;
const ApiErrorSerializers_1 = require("@deliverr/commons-logs/lib/ApiErrorSerializers");
const _ = __importStar(require("lodash"));
function handleApiError(ex, defaultError, failedFn, timedOutFn = failedFn, unhandledFn = failedFn, failedStatusCodes = [400, 404, 422, 500, 503], timedOutStatusCodes = [504]) {
    const responseData = _.get(ex, "response.data");
    const httpStatusCode = _.get(ex, "response.status");
    const error = Object.assign(Object.assign({}, defaultError), { payload: Object.assign(Object.assign({}, (0, ApiErrorSerializers_1.apiErrorSerializer)(ex)), { responseData }) });
    let data;
    if (httpStatusCode === undefined) {
        switch (ex.code) {
            case "ECONNREFUSED":
                data = failedFn();
                break;
            case "ECONNABORTED":
            case "ECONNRESET":
                data = timedOutFn();
                break;
            default:
                data = unhandledFn();
                break;
        }
    }
    else if (failedStatusCodes.includes(httpStatusCode)) {
        data = failedFn();
    }
    else if (timedOutStatusCodes.includes(httpStatusCode)) {
        data = timedOutFn();
    }
    else {
        data = unhandledFn();
    }
    return { data, error };
}
exports.handleApiError = handleApiError;
//# sourceMappingURL=ApiErrorHandler.js.map